import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import { SignupButtonText } from '@segment/matcha/recipes/SignupButton'

import DemoForm from '@segment/templates/Forms/DemoForm'

import HeroImage from './HeroImage'

const copy = {
  overline: `Connections`,
  heading: `Connect all of your customer data`,
  description: `Segment is the single platform to collect, unify, and activate your first-party data.`,
  linkText: `Create a free account`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  const afterContent = (
    <SignupButtonText size="medium" tag="a" iconEnd={ChevronRightIcon}>
      {copy.linkText}
    </SignupButtonText>
  )

  return (
    <Wrapper>
      <HeroComponent variant="centered">
        <HeroCopy>
          <CopyTextBase centered={true}>
            <CopyText.Overline variant="h5">{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="h2">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <DemoForm
              data-hook="demoFormContainer"
              isProgressive={true}
              customFormIdentifier="site-connections-demo"
              successMessageAppearance="twilioLight"
              after={afterContent}
            />
          </HeroRecipe.Form>
        </HeroCopy>
        <HeroRecipe.Contents>
          <HeroImage />
        </HeroRecipe.Contents>
      </HeroComponent>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  position: relative;
  z-index: 0;
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const HeroComponent = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    padding-top: 80px;
    padding-bottom: 190px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-left: 0;
      padding-right: 0;
    }
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      row-gap: 20px;
      padding-bottom: 40px;
    }
  }
`

const HeroCopy = styled(HeroRecipe.Copy)`
  max-width: 510px;
`

export default Hero
